export default __webpack_public_path__ + "static/media/hunt-for-hunter-1.30f628df.jpg";